var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 300,
    viewBox: "0 0 288 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_514_11067)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint0_radial_514_11067)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint1_radial_514_11067)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_514_11067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 20,
    width: 240,
    height: 240
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint2_radial_514_11067)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_514_11067)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint3_radial_514_11067)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_514_11067)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.504 27.5151C85.2296 27.5151 31.5038 81.2409 31.5038 147.515C31.5038 178.71 43.4073 207.126 62.9201 228.466C38.998 206.529 24.0004 175.017 24.0004 140.001C24.0004 73.7267 77.7262 20.0009 144 20.0009C179.079 20.0009 210.642 35.0524 232.584 59.0496C211.229 39.4667 182.762 27.5151 151.504 27.5151Z",
    fill: "url(#paint4_radial_514_11067)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_514_11067)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.071 125C255.69 184.195 205.194 230 144 230C82.8057 230 32.3099 184.195 24.9284 125C24.3157 129.914 24 134.92 24 140C24 206.274 77.7258 260 144 260C210.274 260 264 206.274 264 140C264 134.92 263.684 129.914 263.071 125Z",
    fill: "url(#paint5_radial_514_11067)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_514_11067)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.667,
    cy: 116.668,
    r: 43.3333,
    fill: "#FEDB00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_514_11067)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.668,
    cy: 103.334,
    r: 30,
    fill: "#FFF5B9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_514_11067",
    x: 0,
    y: 0,
    width: 288,
    height: 300,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0627451 0 0 0 0 0.0666667 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_514_11067"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_514_11067",
    result: "effect2_dropShadow_514_11067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_514_11067",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_514_11067",
    x: 8,
    y: 4.00098,
    width: 240.584,
    height: 240.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_514_11067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_514_11067",
    x: 8,
    y: 109,
    width: 272,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_514_11067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_514_11067",
    x: 113.334,
    y: 49.3345,
    width: 134.666,
    height: 134.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_514_11067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_514_11067",
    x: 126.668,
    y: 49.3345,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_514_11067"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_514_11067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189 110) rotate(63.435) scale(83.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#2B2A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_514_11067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189 110) rotate(63.435) scale(83.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#57B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8EC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_514_11067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3972) scale(96.6666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DAFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#127BAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_514_11067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3972) scale(96.6666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#D4B700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_514_11067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.024 139.976) rotate(-133.613) scale(96.6666 96.6683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#F7D500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_514_11067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3973) scale(96.6668 96.6668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB00",
    stopOpacity: 0.996078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#AE9600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallGold);
export default __webpack_public_path__ + "static/media/ball_gold.79bdb5cc526be587efc672f5bb86e3f1.svg";
export { ForwardRef as ReactComponent };